import React from 'react';

const BurgerIcon = () => (
  <svg
    alt="burger icon"
    width="18"
    height="12"
    focusable="false"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 11.7692H17C17.55 11.7692 18 11.3365 18 10.8076C18 10.2788 17.55 9.8461 17 9.8461H1C0.45 9.8461 0 10.2788 0 10.8076C0 11.3365 0.45 11.7692 1 11.7692ZM1 6.96148H17C17.55 6.96148 18 6.52879 18 5.99994C18 5.4711 17.55 5.03841 17 5.03841H1C0.45 5.03841 0 5.4711 0 5.99994C0 6.52879 0.45 6.96148 1 6.96148ZM0 1.19225C0 1.7211 0.45 2.15379 1 2.15379H17C17.55 2.15379 18 1.7211 18 1.19225C18 0.663405 17.55 0.230713 17 0.230713H1C0.45 0.230713 0 0.663405 0 1.19225Z"
      fill="#0D0D0D"
    />
  </svg>
);

export default BurgerIcon;
